if (!customElements.get('gallery-zoom')) {
  customElements.define(
    'gallery-zoom',
    class GalleryZoom extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-zoom-button]');
        this.modal = document.querySelector('custom-dialog[data-name="product-gallery"]');
        if (!this.button || !this.modal) return;
        this.button.addEventListener('click', () => {
          this.modal.openDialog();
          // Let the dialog render before scrolling to the clicked image.
          setTimeout(() => {
            const item = this.modal.querySelector(
              `[data-fullscreen-item][data-media-id="${this.dataset.mediaId}"]`
            );
            item?.scrollIntoView({ behavior: 'instant', block: 'start' });
            this.modal.querySelector('[data-content]')?.focus();
          }, 50);
        });
      }
    }
  );
}
